export function inPriorityOrder(a, b) {
    return -(b.priority || 100) + (a.priority || 100)
}
